// Deletion buttons for file uploads
document.querySelectorAll('.btn-reset-file').forEach(button => {
    button.addEventListener('click', function() {
        const fileInputId = this.dataset.fileInputId;
        const fileInput = document.getElementById(fileInputId);
        if (fileInput) {
            fileInput.value = ''; // Clear the selected file
        }
    });
});
